export var INSTAGRAM_WIDTH = 1080;
export var INSTAGRAM_HEIGHT = 1350;
export var MAX_SLIDER_SELECTION = 8;
// Rendered at this multiple of the logical size so downscaled photos stay sharp.
export var EXPORT_SCALE = 2;
